  import IconDon from "@/assets/icons/donLinear.svg?react"
  import IconDonOrdinary from "@/assets/icons/don-ordinary.svg?react"
  import IconClock from "@/assets/icons/icon-clock.svg?react"
  import IconCheck from "@/assets/icons/check.svg?react"
  import BaseButton from "@/components/base/button/BaseButton.tsx";
  import IconNotes from "@/assets/icons/notes.svg?react"
  import { InfoDataProps } from "@/pages/get-don/tasks.types.ts";
  import { useTranslation } from "react-i18next";

  interface InfoItemProps  {
    id: number
    time: string
    result: string
    collected_don : string
    result_percent: string
    status: string
    onRetry?: () => void
    onBack?: () => void
    onReview?: () => void
  }

  const FinishTest = (props: InfoItemProps) => {
    const {t} = useTranslation()

    // boom() is called from processResult/handleGetDon — no need here
    const infoData: InfoDataProps[]  = [
      {
        id: "1",
        title: "spent_time",
        description: props.time,
        item: 'time'
      },
      {
        id: "2",
        title: "result",
        description: props.result,
        item: "result"
      }
    ]
    return (
      <div className="fixed inset-0 z-40 bg-dark flex flex-col items-center justify-between py-safe-top pb-safe-bottom">
        {/* Top content */}
        <div className="flex flex-col items-center justify-center w-full px-4 flex-1">
          <div className="mb-3">
            <img src="/images/finish.svg" alt="" />
          </div>

          <div className="flex mb-2 items-center justify-center">
            {props.status === "success" ? (
              <IconDon width="34px" height="34px" />
            ) : (
              <IconDonOrdinary className="text-gray-1" width="34px" height="34px" />
            )}
            <p className={`${props.status === 'success' ? 'bg-yellow-linear' : 'bg-gray-1'} text-transparent bg-clip-text text-5xl font-bold leading-130`}>
              {props.collected_don}
            </p>
          </div>

          {props.status === "success" ? (
            <p className="text-center mb-6 font-normal text-gray-1 leading-140 text-sm">
              {t("test_success_message", { percent: props.result_percent, don: props.collected_don })
                .replace("{percent}", props.result_percent)
                .replace("{don}", props.collected_don)}
            </p>
          ) : (
            <p className="text-center mb-6 font-normal text-gray-1 leading-140 text-sm">
              {t("test_fail_message")}
            </p>
          )}

          <div className="flex items-center w-full gap-2 justify-center">
            {infoData.map((item, index) => (
              <div key={index} className="flex items-center w-full px-2 py-1 bg-white/08 rounded-10 gap-2 justify-start">
                <div className={`${item.item === 'result' ? 'bg-green' : 'bg-yellow'} flex items-center justify-center p-1.5 rounded-lg`}>
                  {item.item === 'result' ? (
                    <IconCheck width="18px" height="18px" />
                  ) : item.item === 'time' ? (
                    <IconClock width="18px" height="18px" />
                  ) : null}
                </div>
                <div>
                  <p className="text-xs text-gray-1 leading-130 font-normal">{t(item.title)}</p>
                  <h2 className="text-sm font-semibold leading-130 text-white">{item.description}</h2>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom buttons */}
        <div className="w-full px-4 grid gap-y-2 pb-4">
          <BaseButton prefix={<IconNotes />} text={t('view_results')} variant="secondary" className="w-full" onClick={props.onReview} />
          <BaseButton
            text={props.status === 'success' ? props.collected_don + " " + t('get_don') : t('retry')}
            variant={props.status === 'success' ? "premium" : "primary"}
            className={`w-full text-sm leading-130 font-semibold ${props.status === 'success' ? 'text-black' : 'text-white'}`}
            onClick={props.status === 'success' ? props.onBack : props.onRetry}
          />
        </div>
      </div>
    );
  };

  export default FinishTest;
